import React from "react";

const Hero = ({
  pretitle,
  title,
  description,
  primaryLink,
  secondaryLink,
  users = [],
  imageSrc,
  features = [],
  price,
  duration,
}) => {
  return (
    <section className="banner lg:px-28 md:px-14 px-4 min-h-[80vh] md:min-h-screen py-10 md:py-16 items-center">
      <div className="mx-auto py-2 sm:py-4">
        <div className="grid items-center gap-10 flex-col-reverse md:grid-cols-2">
          <div className="max-w-full md:max-w-xl">
            {pretitle && (
              <div className="inline-flex items-center border-[#12105E33] gap-2 rounded-full bg-blue-50 px-4 py-2 text-[11px] font-semibold uppercase tracking-wider text-[#12105E]">
                <span className="h-2 w-2 rounded-full bg-[#12105E33]" />
                {pretitle}
              </div>
            )}

            {title && (
              <h1 className="mt-6 text-3xl sm:text-5xl text-slate-900 leading-snug md:text-4xl lg:text-5xl">
                {title}
              </h1>
            )}

            {description && (
              <p className="mt-5 max-w-lg text-base leading-relaxed text-slate-600 sm:text-lg">
                {description}
              </p>
            )}

            {(price || duration) && (
              <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-6">
                {price && (
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-slate-600">
                      Price -
                    </span>
                    <span className="text-2xl font-bold text-[#E17A01]">
                      {price}
                    </span>
                  </div>
                )}
                {duration && (
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-slate-600">
                      Duration -
                    </span>
                    <span className="text-lg font-semibold text-slate-900">
                      {duration}
                    </span>
                  </div>
                )}
              </div>
            )}

            <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:flex-wrap">
              {primaryLink && (
                <a
                  href={primaryLink.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex w-full items-center justify-center gap-2 rounded-full bg-[#E17A01] px-6 py-4 font-semibold text-white shadow-lg transition hover:bg-[#f98604] sm:w-auto"
                >
                  {primaryLink.text}
                </a>
              )}

              {secondaryLink && (
                <a
                  href={secondaryLink.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex w-full items-center justify-center gap-2 rounded-full border border-slate-200 bg-white px-6 py-4 font-semibold text-slate-700 transition hover:border-slate-300 sm:w-auto"
                >
                  {secondaryLink.text}
                </a>
              )}
            </div>

            {users.length > 0 && (
              <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center">
                <div className="flex -space-x-2 overflow-hidden">
                  {users.map((u, i) => (
                    <img
                      key={i}
                      src={u}
                      alt={`User ${i + 1}`}
                      className={`h-9 w-9 rounded-full border-2 border-white bg-slate-${300 + i * 100}`}
                    />
                  ))}
                </div>

                <p className="text-sm text-slate-500">
                  Join 500+ successful graduates
                </p>
              </div>
            )}
          </div>

          <div className="relative">
            <div className="overflow-hidden rounded-[2rem] h-[280px] sm:h-[340px] md:h-[420px]">
              <img
                src={imageSrc}
                alt="Hero"
                className="w-full h-full rounded-[2rem] object-cover"
              />
            </div>

            <div className="absolute -left-8 top-10 hidden rounded-2xl bg-white px-4 py-3 shadow-lg md:flex items-center gap-3">
              {/* optionally a small stat card could be placed here by parent via CSS override */}
              {/* <div>
                  <p className="text-xs text-slate-500">Protection Rate</p>
                  <p className="font-bold text-slate-900">99.9%</p>
                </div> */}
            </div>
          </div>
        </div>
      </div>

      <section className=" py-12">
        <div className="mx-auto ">
          <div className="grid gap-10 lg:grid-cols-[1.1fr_1.6fr] lg:items-start">
            <div>
              <h2 className="max-w-md text-2xl  leading-tight text-[#12105E] md:text-4xl">
                Expertise Built for the Real World
              </h2>

              <p className="mt-6 max-w-md leading-8 text-gray-600">
                {
                  "Our curriculum is designed by active security analysts to bridge the gap between theory and actual threat mitigation."
                }
              </p>

              <div className="mt-10 flex items-start gap-4 border-l-4 border-orange-500 bg-gray-50 p-5">
                <div className="mt-1 text-orange-500">🌐</div>

                <div>
                  <h4 className="font-bold uppercase text-gray-900">
                    Flexible Learning Modes
                  </h4>
                  <p className="mt-1 text-sm text-gray-600">
                    Available in Online and Onsite modes.
                  </p>
                </div>
              </div>
            </div>

            <div className="grid gap-6 md:grid-cols-2">
              {features.map((feature) => {
                const Icon = feature.icon;

                return (
                  <div
                    key={feature.id}
                    className="border border-gray-200 bg-white p-8 transition hover:shadow-lg"
                  >
                    {Icon && (
                      <Icon
                        size={28}
                        className="text-orange-500"
                      />
                    )}

                    <h3 className="mt-6 text-3xl  text-gray-900">
                      {feature.title}
                    </h3>

                    <p className="mt-4 leading-7 text-gray-600">
                      {feature.description}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default Hero;
